<template>
  <DialogYesNo
    title="Set quiz date"
    v-bind:visible="visible"
    @hidden="updateVmodel"
    @ok="submit"
  >
    <p>
      Here you can define when this quiz should be taking place. The date you
      set will be used for the calendar, if you choose to display it there.
    </p>
    <b-form @submit.prevent="submit">
      <b-form-group label="Quiz Date" label-for="qDate">
        <b-form-datepicker id="qDate" v-model="myDate" />
      </b-form-group>
      <b-form-group label="Quiz Time" label-for="time">
        <b-form-input id="time" v-model="myTime" type="time" />
      </b-form-group>
    </b-form>
    <p class="text-muted text-medium">
      Note: You must supply a date and a time, otherwise the quiz date will not
      be set.
    </p>
  </DialogYesNo>
</template>

<script>
import DialogYesNo from "@/components/DialogYesNo";

export default {
  name: "DialogQuizDate",
  props: {
    visible: {
      default: false
    },
    quiz: {}
  },
  components: {
    DialogYesNo
  },
  data() {
    return {
      myDate: "",
      myTime: ""
    };
  },
  model: {
    prop: "visible",
    event: "hidden"
  },
  created() {
    if (this.quiz.event_time > 0) {
      this.myDate = this.$moment(this.quiz.event_time).format("YYYY-MM-DD");
      this.myTime = this.$moment(this.quiz.event_time).format("HH:mm");
    }
  },
  methods: {
    updateVmodel() {
      this.$emit("hidden", false);
    },
    submit(ev) {
      var eventTime = this.$moment(this.myDate + " " + this.myTime).valueOf();
      if (isNaN(eventTime)) {
        eventTime = 0;
      }

      this.$emit("ok", ev, eventTime);
    }
  }
};
</script>
